import React from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { MindMapDemo } from '../components/MindMapDemo';
import { Network, Eye, RefreshCw, Layers, Users, AlertTriangle, MessageSquare, Database } from 'lucide-react';
/*
  SEO SPECIFICATION:
  Title: Live Business Mind Map — See Your Entire Business in Real Time | MindStream.ing
  Meta Desc: A self-updating visual of every project, client, team member, and task — live, in real time, always current. Not a static diagram. A living business map.
  Primary KW: live business mind map AI
*/
export function LiveMindMaps() {
  return <FeaturePageLayout seoTitle="Live Mind Maps — Visual Business Operations | MindStream.ing" seoDesc="See your entire business operation in real-time. Watch data flow, spot bottlenecks, and understand your systems visually." heroEyebrow="" heroTitle={<></>} heroDesc="" heroImage="" customContent={<div className="flex flex-col items-center w-full" data-id="element-1808" data-mp="22cscolsulitn">
          <div className="text-center mb-12" data-id="element-1809" data-mp="3hq38pdyx0vcb">
            <h2 className="font-poppins font-bold text-3xl md:text-4xl mb-4" data-id="element-1810" data-mp="3csb69q0n9qtv">
              Your Business, Visualized
            </h2>
            <p className="text-steel max-w-2xl mx-auto" data-id="element-1811" data-mp="3rg60jauaw392">
              Explore a live, interactive map of your entire operation. Switch
              between infrastructure and agent team views to see exactly how
              MISTR connects everything.
            </p>
          </div>
          <MindMapDemo data-id="element-1812" data-mp="2ttyv5yq6a6vn" />
        </div>} problem={{
    subtitle: "You can't see the big picture. Information is scattered across tools, inboxes, and heads.",
    cards: [{
      icon: <Eye size={32} data-id="element-1813" data-mp="33qtu2iqcy9ag" />,
      title: 'Blind Spots',
      desc: "You don't know what's blocking a project until it's already late because the data is hidden in a tool you don't check."
    }, {
      icon: <Network size={32} data-id="element-1814" data-mp="j3gvmefrkpsp" />,
      title: 'Static Diagrams',
      desc: "You spend hours building a beautiful org chart or process map, and it's outdated the moment you hit save."
    }]
  }} howItWorks={{
    title: 'How It Works',
    steps: [{
      title: 'MR Maps',
      desc: 'MR automatically maps your entire business structure and current state.'
    }, {
      title: 'Real-Time Updates',
      desc: 'The map updates instantly as your business changes.'
    }, {
      title: 'Deep Dive',
      desc: 'Click into any node to see the full context, history, and blockers.'
    }]
  }} features={{
    cards: [{
      icon: <Layers size={24} data-id="element-1815" data-mp="36ymdyz1lxbkh" />,
      title: 'Projects Visualization',
      desc: 'See every active project, its status, and how it connects to your goals.'
    }, {
      icon: <Users size={24} data-id="element-1816" data-mp="2ee4b2e6mykjj" />,
      title: 'Client Relationships',
      desc: 'Map out every client interaction, deal stage, and account health.'
    }, {
      icon: <Network size={24} data-id="element-1817" data-mp="21w1x5i0tm56g" />,
      title: 'Team Assignments',
      desc: 'Visualize who is working on what, and identify overloaded team members.'
    }, {
      icon: <RefreshCw size={24} data-id="element-1818" data-mp="1szawesbbq25j" />,
      title: 'Task Status',
      desc: 'Watch tasks move from to-do to done in real time across the entire company.'
    }, {
      icon: <AlertTriangle size={24} data-id="element-1819" data-mp="1j5aj435w1qlq" />,
      title: 'Blocker Identification',
      desc: 'MR highlights bottlenecks in red before they impact delivery.'
    }]
  }} demoCallout="Use Cases: Weekly review, client presentation, team onboarding, investor update." data-id="element-1807" data-mp="333nvjazryn0" />;
}